export default (time) => `${time}:00-03:00`;
